import React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';

const columns = [
    {
        field: 'internal_po_number',
        headerName: 'PO Number',
        flex: 1,
        minWidth: 150,
        editable: false
    },
    {
        field: 'case_pack_count',
        headerName: 'Case Pack Count',
        flex: 1,
        minWidth: 150,
        editable: false
    },
    {
        field: 'total_qty',
        headerName: 'Total Qty',
        flex: 1,
        minWidth: 125,
        editable: false
    },
    {
        field: 'pallet_count',
        headerName: 'Pallet Count',
        flex: 1,
        minWidth: 125,
        editable: false
    }
];

function WalmartPalletAllocationSummaryTable(props) {

    return (
        <Box sx={{ mt: '20px' }}>
            <DataGrid
                className={
                    props.isMobile
                        ? "mobile-table"
                        : "desktop-table"
                }
                rows={props.orders}
                columns={columns}
                getRowId={(row) => row.internal_po_number}
                hideFooter
                checkboxSelection={false}
                autoHeight
            />
        </Box>
    );
}

export default WalmartPalletAllocationSummaryTable;